// External Dependencies:
import React from 'react'
import { connect } from 'react-redux'

// Internal Dependencies:
import Map from 'components/svg/aus-states'

class Events extends React.Component {
	render() {
		const { page } = this.props

		return (
			<div className="events-map">
				<Map />
			</div>
		)
	}
}

const mapStateToProps = ( state, ownProps ) => {
	return {
		page: state.page.selected
	}
}

export default connect( mapStateToProps )( Events )



// WEBPACK FOOTER //
// ./views/page/Events.jsx